var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5692e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3081.6 540c-694.8-68.398-1090.8-378-1090.8-381.6-108-93.602-270-93.602-381.6 0-3.6016 3.6016-396 313.2-1090.8 381.6-151.2 14.398-266.4 140.4-266.4 295.2 0 2005.2 1371.6 2624.4 1429.2 2649.6 36 18 79.199 25.199 118.8 25.199s82.801-7.1992 118.8-25.199c57.598-25.199 1429.2-644.4 1429.2-2649.6 0-154.8-115.2-280.8-266.4-295.2zm-594 2080.8-14.398-129.6c-18-180-136.8-327.6-295.2-399.6-108 64.801-237.6 104.4-374.4 104.4-136.8 0-262.8-39.602-374.4-104.4-158.4 72-273.6 219.6-295.2 399.6l-14.398 133.2c-288-363.6-558-928.8-565.2-1774.8 799.2-79.199 1245.6-439.2 1242-450 21.602 18 464.4 367.2 1245.6 446.4-7.2109 846-273.61 1411.2-554.41 1774.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2271.6 1468.8c0 168.48-89.887 324.17-235.8 408.42-145.91 84.242-325.69 84.242-471.6 0-145.91-84.246-235.8-239.93-235.8-408.42 0-168.49 89.887-324.18 235.8-408.42 145.91-84.242 325.69-84.242 471.6 0 145.91 84.242 235.8 239.93 235.8 408.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin2);
export default __webpack_public_path__ + "static/media/admin2.3423ef82f7604512e013e36c6070049e.svg";
export { ForwardRef as ReactComponent };